import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;
    // Defer so react-helmet has time to update document.title for the new route.
    const timer = setTimeout(() => {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 100);
    return () => clearTimeout(timer);
  }, [location]);
}; 